import axios from "axios"
import authenticate from "../../erp_src/helper/authenticate"
import errorHandling from "../../erp_src/helper/errorHandling"

export default {
	namespaced: true,
	state: {
		authData: {
			id: null,
			uid: null,
			client: null,
			admin: null,
			account_type: null,
			accessToken: null,
			company_id: null,
			full_name: null,
			user_departments: [],
		},
	},
	getters: {
		authData: (state) => state.authData,
		isAuthenticated(state) {
			return state.authData.uid && state.authData.accessToken && state.authData.client
		},
		isOwner:
			(state) =>
			(obj, key = null) => {
				if (key) {
					return state.authData.id == obj[key]
				} else {
					return state.authData.id == obj.user_id
				}
			},
	},
	mutations: {
		setAuthData(state) {
			state.authData.accessToken = localStorage.getItem("access-token")
			state.authData.client = localStorage.getItem("client")
			state.authData.uid = localStorage.getItem("uid")
		},
		updateAuthData(state, { user, user_departments }) {
			state.authData.accessToken = localStorage.getItem("access-token")
			state.authData.client = localStorage.getItem("client")
			state.authData.uid = localStorage.getItem("uid")
			state.authData.id = user.id
			state.authData.admin = user.admin
			state.authData.company_id = user.company_id
			state.authData.account_type = user.account_type
			state.authData.full_name = `${user.last_name} ${user.first_name}`
			state.authData.user_departments = user_departments
		},
		removeAuthData(state) {
			state.authData.accessToken = null
			state.authData.client = null
			state.authData.uid = null
			state.authData.id = null
			state.authData.admin = null
			state.authData.company_id = null
			state.authData.account_type = null
			state.authData.full_name = null
			state.authData.user_departments = []
		},
		updateUid(state) {
			state.authData.uid = localStorage.getItem("uid")
		},
	},
	actions: {
		login({ commit, dispatch }, { email, password }) {
			return axios
				.post(`/api/v1/auth/sign_in`, { email, password })
				.then((res) => {
					// メール認証時は以降の処理をスルー
					if (res.data.message) {
						const user_include_sales = null
						const message = res.data.message
						return { user_include_sales, message }
					}
					localStorage.setItem("access-token", res.headers["access-token"])
					localStorage.setItem("client", res.headers["client"])
					localStorage.setItem("expiry", res.headers["expiry"])
					localStorage.setItem("uid", res.headers["uid"])
					commit("updateAuthData", {
						user: res.data.user,
						user_departments: res.data.user_departments,
					})
					commit("setMessageCount", res.data.message_count, { root: true })
					commit("setDepartments", res.data.departments, { root: true })
					dispatch("setMessageInterval", null, { root: true })
					const user_include_sales = res.data.user_departments.map((d) => d.name).includes("営業部")
					return { user_include_sales }
				})
				.catch((err) => {
					throw err
				})
		},
		autoLogin({ commit, dispatch }) {
			const expiryTime = localStorage.getItem("expiry")
			const accessToken = localStorage.getItem("access-token")
			const client = localStorage.getItem("client")
			const uid = localStorage.getItem("uid")
			if (!expiryTime || !accessToken || !client || !uid) return
			const now = new Date()
			if (expiryTime > now.getTime()) {
				dispatch("logout")
				return
			}
			commit("setAuthData")
			const headers = {
				"access-token": accessToken,
				uid,
				client,
			}
			axios
				.get("/erp/v1/erp_app", { headers })
				.then((res) => {
					commit("updateAuthData", {
						user: res.data.current_user,
						user_departments: res.data.user_departments,
					})
					commit("setMessageCount", res.data.message_count, { root: true })
					commit("setDepartments", res.data.departments, { root: true })
					dispatch("setMessageInterval", null, { root: true })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		logOut({ commit }) {
			const accessToken = localStorage.getItem("access-token")
			const client = localStorage.getItem("client")
			const uid = localStorage.getItem("uid")
			axios.delete("/api/v1/auth/sign_out", {
				headers: {
					"access-token": accessToken,
					client: client,
					uid: uid,
				},
			})
			localStorage.removeItem("access-token")
			localStorage.removeItem("client")
			localStorage.removeItem("uid")
			localStorage.removeItem("expiry")
			commit("removeAuthData")
		},
		setUid({ commit }, email) {
			localStorage.removeItem("uid")
			localStorage.setItem("uid", email)
			commit("updateUid")
		},
		confirmToken({ state, commit, dispatch }, confirmation_token) {
			const authData = state.authData
			const headers = {
				"access-token": authData.accessToken,
				client: authData.client,
				uid: authData.uid,
			}

			return axios
				.get("/erp/v1/auth/confirmation", {
					params: { confirmation_token },
					headers,
				})
				.then((res) => {
					localStorage.setItem("access-token", res.data.redirect_headers["access-token"])
					localStorage.setItem("client", res.data.redirect_headers["client"])
					localStorage.setItem("expiry", res.data.redirect_headers["expiry"])
					localStorage.setItem("uid", res.data.redirect_headers["uid"])
					commit("updateAuthData", {
						user: res.data.user,
						user_departments: res.data.user_departments,
					})
					commit("setMessageCount", res.data.message_count, { root: true })
					commit("setDepartments", res.data.departments, { root: true })
					dispatch("setMessageInterval", null, { root: true })

					const user_include_sales = res.data.user_departments.map((d) => d.name).includes("営業部")
					return { user_include_sales }
				})
				.catch((err) => {
					throw err
				})
		},
	},
}
